import {
    createPatternFromImage,
    createPatternFromImageForDrawing,
} from './fileHelper'

const defultimgInitialWidth = 100
var imgInitialWidth = defultimgInitialWidth
const imgFinalWidth = 800
const opacity = 0.7

const _defaultOptions = {
    skewSign: 1,
    width: null,
    height: null,
    pathData: null,
    points: [
        [97, 158],
        [432, 102],
        [875, 159],
        [576, 211],
        [879, 398],
        [576, 491],
    ],
    breakRatio: 1,
    corner_points: [
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0],
    ],
    controls: [],
    triangles: [],
    skewAngle: Math.PI / 4,
    showFrame: true,
    subs: (7 * 8) / 2,
    divs: (7 * 8) / 2,
    scaleFactor: 4,
    dirtyTriangles: true,
    canvas: null,
    image: null,
    context: null,
}

let options = {
    ..._defaultOptions,
}

export const warpOnCube = (
    pts,
    mode,
    imgSrc,
    imgWidth,
    imgHeight,
    pathData,
    { zoom, offsetH, offsetV },
    { cornerPoints, breakRatio, skewAngle }
) =>
    new Promise((resolve, reject) => {
        options = { ..._defaultOptions }

        options.width = imgWidth
        options.height = imgHeight
        options.pathData = pathData
        options.corner_points = cornerPoints
        options.breakRatio = breakRatio

        imgInitialWidth = (zoom / 100) * defultimgInitialWidth

        options.points = pts
        options.mode = mode
        options.skewSign = mode == 4 ? -1 : 1

        options.skewAngle = skewAngle

        options.image = new Image()
        options.image.crossOrigin = 'Anonymous'

        options.image.onload = () =>
            draw(() => {
                const { canvas } = options
                let img = canvas.toDataURL('image/png')

                options.context.clip(new Path2D(options.pathData))
                resolve(img)
            })

        createPatternFromImageForDrawing(
            imgSrc,
            imgInitialWidth,
            imgFinalWidth,
            offsetH,
            offsetV
        ).then((imgBase64) => {
            options.image.setAttribute('src', imgBase64)
        })

        options.canvas = document.createElement('canvas')

        options.canvas.width = imgWidth
        options.canvas.height = imgHeight

        document.body.appendChild(options.canvas)
        options.context = options.canvas.getContext('2d')

        options.context.clearRect(
            0,
            0,
            options.canvas.width,
            options.canvas.height
        )
    })

export const warpOnCubeWithControls = (
    canvas,
    pts,
    mode,
    imgSrc,
    imgWidth,
    imgHeight,
    pathData,
    cornerPoints,
    breakRatio,
    skewAngle,
    isNew,
    callback
) => {
    options = { ..._defaultOptions }

    options.width = imgWidth
    options.height = imgHeight
    options.pathData = pathData
    if (cornerPoints) options.corner_points = cornerPoints

    options.points = pts
    options.mode = mode
    options.skewSign = mode == 4 ? -1 : 1

    options.skewAngle = skewAngle
    if (mode != 1) calcLengthAndAngles(breakRatio)
    if (isNew) stretchPoints()

    options.image = new Image()
    options.image.crossOrigin = 'Anonymous'

    options.image.onload = () =>
        draw(() => {
            callback({
                points: options.points,
                cornerPoints: options.corner_points,
                breakRatio: options.breakRatio,
            })
        })

    createPatternFromImage(imgSrc, imgInitialWidth, imgFinalWidth).then(
        (imgBase64) => {
            options.image.setAttribute('src', imgBase64)
        }
    )

    options.canvas = canvas
    options.canvas.width = imgWidth
    options.canvas.height = imgHeight

    options.context = options.canvas.getContext('2d')

    options.context.clearRect(0, 0, options.canvas.width, options.canvas.height)
    options.context.clip(new Path2D(options.pathData))

    let { controls, points } = options

    controls = []
    for (let i = 0; i < 6; i++) {
        let control = document.createElement('div')
        control.setAttribute('data-node', i)
        control.innerText = i + 1
        control.classList.add('node')
        canvas.parentNode.insertBefore(control, canvas.nextSibling)
        controls.push(control)
    }

    controls[0].style.left = points[0][0] + 'px'
    controls[0].style.top = points[0][1] + 'px'

    controls[1].style.left = points[1][0] + 'px'
    controls[1].style.top = points[1][1] + 'px'

    controls[2].style.left = points[2][0] + 'px'
    controls[2].style.top = points[2][1] + 'px'

    controls[3].style.left = points[3][0] + 'px'
    controls[3].style.top = points[3][1] + 'px'

    if (mode == 1) {
        controls[2].style.display = 'none'
        controls[3].style.display = 'none'
    }

    controls[4].style.left = points[4][0] + 'px'
    controls[4].style.top = points[4][1] + 'px'

    controls[5].style.left = points[5][0] + 'px'
    controls[5].style.top = points[5][1] + 'px'

    options.controls = controls
    options.canvas = canvas
    options.context = options.context
}

export const updateCubeByNodes = (e, node, callback) => {
    let { points, skewSign, mode } = options
    options.dirtyTriangles = true

    let nodeIndex = parseInt(node.getAttribute('data-node'))

    if (nodeIndex >= 6) return

    let ratio = 0

    switch (nodeIndex) {
        case 0:
        case 3:
        case 5:
            let l03 = lengthOf(0, 3)
            let l05 = lengthOf(0, 5)
            ratio = l03 / l05
            break
        case 1:
        case 2:
        case 4:
            let l12 = lengthOf(1, 2)
            let l14 = lengthOf(1, 4)
            ratio = l12 / l14
            break
        default:
            break
    }

    let dx = e.pageX - points[nodeIndex][0]
    let dy = e.pageY - points[nodeIndex][1]
    let x = e.pageX
    let y = e.pageY

    //#region Block Extra Y Movement
    if (nodeIndex == 0) {
        if (y >= points[5][1]) {
            y = points[5][1]
            dy = 0
        }
    }

    if (nodeIndex == 1) {
        if (y >= points[4][1]) {
            y = points[4][1]
            dy = 0
        }
    }

    if (nodeIndex == 5) {
        if (y <= points[0][1]) {
            y = points[0][1]
            dy = 0
        }
    }

    if (nodeIndex == 4) {
        if (y <= points[1][1]) {
            y = points[1][1]
            dy = 0
        }
    }
    //#endregion

    //#region Block Perspective Left Extra X Movement

    if (mode == 3) {
        if (nodeIndex == 5) {
            if (x <= points[0][0] + 5) {
                x = points[0][0] + 5
                dx = 0
                dy = 0
            }
        }

        if (nodeIndex == 4) {
            if (x <= points[1][0] + 5) {
                x = points[1][0] + 5
                dx = 0
                dy = 0
            }
        }
    }
    //#endregion

    //#region Block Perspective Right Extra X Movement

    if (mode == 4) {
        if (nodeIndex == 5) {
            if (x >= points[0][0] - 5) {
                x = points[0][0] - 5
                dx = 0
                dy = 0
            }
        }

        if (nodeIndex == 4) {
            if (x >= points[1][0] - 5) {
                x = points[1][0] - 5
                dx = 0
                dy = 0
            }
        }
    }

    //#endregion

    //#region Block Perspective Front Extra X Movement

    if (mode == 2) {
        if (nodeIndex == 5) {
            if (x <= points[0][0] + 5) {
                x = points[0][0] + 5
                dx = 0
                dy = 0
            }
        }

        if (nodeIndex == 4) {
            if (x >= points[1][0] - 5) {
                x = points[1][0] - 5
                dx = 0
                dy = 0
            }
        }
    }

    //#endregion

    if (nodeIndex == 3 || nodeIndex == 2) {
        let alpha = 1

        if (nodeIndex == 3) {
            alpha = Math.atan2(
                points[5][1] - points[0][1],
                points[5][0] - points[0][0]
            )
        } else
            alpha = Math.atan2(
                points[4][1] - points[1][1],
                points[4][0] - points[1][0]
            )

        x = points[nodeIndex][0] + dx
        y = points[nodeIndex][1] + dx * Math.tan(alpha)

        if (nodeIndex == 3) {
            if (skewSign > 0) {
                if (x < points[0][0]) {
                    x = points[0][0]
                }
                if (x > points[5][0]) {
                    x = points[5][0]
                }
                if (y < points[0][1]) {
                    y = points[0][1]
                }
                if (y > points[5][1]) {
                    y = points[5][1]
                }
            } else {
                if (x > points[0][0]) {
                    x = points[0][0]
                }
                if (x < points[5][0]) {
                    x = points[5][0]
                }
                if (y < points[0][1]) {
                    y = points[0][1]
                }
                if (y > points[5][1]) {
                    y = points[5][1]
                }
            }
        }

        if (nodeIndex == 2) {
            if (skewSign > 0 && mode != 2) {
                if (x < points[1][0]) {
                    x = points[1][0]
                }
                if (x > points[4][0]) {
                    x = points[4][0]
                }

                if (y < points[1][1]) {
                    y = points[1][1]
                }
                if (y > points[4][1]) {
                    y = points[4][1]
                }
            } else {
                if (x > points[1][0]) {
                    x = points[1][0]
                }
                if (x < points[4][0]) {
                    x = points[4][0]
                }

                if (y < points[1][1]) {
                    y = points[1][1]
                }
                if (y > points[4][1]) {
                    y = points[4][1]
                }
            }
        }
    }

    node.style.left = x + 'px'
    node.style.top = y + 'px'

    points[nodeIndex] = [x, y]

    updateSameLinePoints(nodeIndex, dx, dy, ratio)

    updateCornerPoints(nodeIndex, dx, dy, ratio)

    calcBreakLine(nodeIndex)

    draw(() =>
        callback({
            points: options.points,
            cornerPoints: options.corner_points,
            breakRatio: options.breakRatio,
        })
    )
}

export const updateCubeSkewAngle = (skewAngle, callback) => {
    options.skewAngle = skewAngle

    draw(() =>
        callback({
            points: options.points,
            cornerPoints: options.corner_points,
            breakRatio: options.breakRatio,
        })
    )
}

const calcLengthAndAngles = (breakRatio = null) => {
    const { skewSign, points } = options

    let deviation = Math.abs(Math.abs(angleOf(3, 2)) - Math.abs(angleOf(1, 2)))

    if (skewSign < 0) {
        const skewAngle =
            Math.PI / 4 -
            (Math.abs(angleOf(3, 2)) > Math.PI / 2
                ? Math.PI - Math.abs(angleOf(3, 2))
                : Math.abs(angleOf(3, 2)))
        // options.skewAngle = skewAngle - deviation
    } else {
        const skewAngle = Math.PI / 4
        // Math.PI / 4 +
        // (Math.abs(angleOf(3, 2)) > Math.PI / 2
        //     ? Math.PI - Math.abs(angleOf(3, 2))
        //     : Math.abs(angleOf(3, 2)))
        // options.skewAngle = skewAngle + deviation
    }

    calcBreakLine(null, breakRatio)
}

const calcBreakLine = (nodeIndex = 3, breakRatio) => {
    if (breakRatio) {
        options.breakRatio = breakRatio
        return
    }

    const { subs } = options

    options.breakRatio = 0

    if (nodeIndex == 3)
        options.breakRatio = lengthOf(0, 3) / (lengthOf(5, 3) + lengthOf(0, 3))
    else options.breakRatio = lengthOf(1, 2) / (lengthOf(4, 2) + lengthOf(1, 2))

    options.breakRatio = Math.round(subs * options.breakRatio)
}

const stretchPoints = () => {
    const baseLength = 200

    let d0_3 = lengthOf(0, 3)
    let d3_5 = lengthOf(3, 5)
    let d0_1 = lengthOf(0, 1)
    let d2_3 = lengthOf(2, 3)
    let d2_4 = lengthOf(2, 4)
    let d1_2 = lengthOf(1, 2)

    const targetAngle1 = -(Math.PI / 2 + angleOf(0, 3))
    const targetAngle2 = -(Math.PI / 2 + angleOf(1, 2))

    // extend shape with amount of break point (cube edge) points 3, 4
    const { points, corner_points, skewSign, mode } = options
    let { scaleFactor } = options

    let length = lengthOf(3, 5)
    points[5][0] = points[3][0] + length * Math.sin(targetAngle1)
    points[5][1] = points[3][1] + length * Math.cos(targetAngle1)

    length = lengthOf(2, 4)
    points[4][0] = points[2][0] + length * Math.sin(targetAngle2)
    points[4][1] = points[2][1] + length * Math.cos(targetAngle2)

    if (d3_5 == 0) d3_5 = d0_3
    if (d2_4 == 0) d2_4 = d1_2

    const maxLength = Math.max(...[d0_3, d3_5, d0_1, d2_3, d2_4, d1_2])

    d0_3 = (d0_3 / maxLength) * baseLength
    d3_5 = (d3_5 / maxLength) * baseLength
    d0_1 = (d0_1 / maxLength) * baseLength
    d2_3 = (d2_3 / maxLength) * baseLength
    d2_4 = (d2_4 / maxLength) * baseLength
    d1_2 = (d1_2 / maxLength) * baseLength

    if (mode == 1) scaleFactor /= 2

    corner_points[0][0] =
        points[0][0] +
        (scaleFactor * d0_3 * Math.cos(angleOf(0, 3)) +
            scaleFactor * d0_1 * Math.cos(angleOf(0, 1)))
    corner_points[0][1] =
        points[0][1] +
        (scaleFactor * d0_3 * Math.sin(angleOf(0, 3)) +
            scaleFactor * d0_1 * Math.sin(angleOf(0, 1)))

    corner_points[3][0] =
        points[5][0] +
        (scaleFactor * d2_3 * Math.cos(angleOf(3, 2)) -
            scaleFactor * d3_5 * Math.cos(angleOf(0, 3)))
    corner_points[3][1] =
        points[5][1] +
        (scaleFactor * d2_3 * Math.sin(angleOf(3, 2)) -
            scaleFactor * d3_5 * Math.sin(angleOf(0, 3)))

    corner_points[1][0] =
        points[1][0] +
        (scaleFactor * d1_2 * Math.cos(angleOf(1, 2)) -
            scaleFactor * d0_1 * Math.cos(angleOf(0, 1)))
    corner_points[1][1] =
        points[1][1] +
        (scaleFactor * d1_2 * Math.sin(angleOf(1, 2)) -
            scaleFactor * d0_1 * Math.sin(angleOf(0, 1)))

    corner_points[2][0] =
        points[4][0] +
        (-scaleFactor * d2_4 * Math.cos(angleOf(1, 2)) -
            scaleFactor * d2_3 * Math.cos(angleOf(3, 2)))
    corner_points[2][1] =
        points[4][1] +
        (-scaleFactor * d2_4 * Math.sin(angleOf(1, 2)) -
            scaleFactor * d2_3 * Math.sin(angleOf(3, 2)))

    options.corner_points = corner_points
    options.points = points
}

const updateCornerPoints = (nodeIndex, dx, dy, ratio) => {
    const { corner_points, scaleFactor } = options

    switch (nodeIndex) {
        case 0: //corner point index of 3
            corner_points[0][0] += dx * scaleFactor
            corner_points[0][1] += dy * scaleFactor
            break
        case 1: //corner point index of 3
            corner_points[1][0] += dx * scaleFactor
            corner_points[1][1] += dy * scaleFactor
            break
        case 4: //corner point index of 3
            corner_points[2][0] += dx * scaleFactor
            corner_points[2][1] += dy * scaleFactor
            break
        case 5: //corner point index of 3
            corner_points[3][0] += dx * scaleFactor
            corner_points[3][1] += dy * scaleFactor
            break

        default:
            break
    }
    options.corner_points = corner_points
}

const updateSameLinePoints = (nodeIndex, dx, dy, ratio) => {
    let { points, controls } = options
    let deltaX, deltaY, alpha
    switch (nodeIndex) {
        case 0:
        case 5:
            deltaX = ratio * dx
            deltaY = ratio * dy

            points[3][0] += deltaX
            points[3][1] += deltaY

            controls[3].style.left = points[3][0] + 'px'
            controls[3].style.top = points[3][1] + 'px'
            break
        case 1:
        case 4:
            deltaX = ratio * dx
            deltaY = ratio * dy

            points[2][0] += deltaX
            points[2][1] += deltaY

            controls[2].style.left = points[2][0] + 'px'
            controls[2].style.top = points[2][1] + 'px'
            break

        case 2:
            alpha = angleOf(5, 0)
            points[3][0] =
                points[0][0] + ratio * lengthOf(0, 5) * Math.cos(alpha)
            points[3][1] =
                points[0][1] + ratio * lengthOf(0, 5) * Math.sin(alpha)
            controls[3].style.left = points[3][0] + 'px'
            controls[3].style.top = points[3][1] + 'px'
            break

        case 3:
            alpha = angleOf(4, 1)
            points[2][0] =
                points[1][0] + ratio * lengthOf(1, 4) * Math.cos(alpha)
            points[2][1] =
                points[1][1] + ratio * lengthOf(1, 4) * Math.sin(alpha)
            controls[2].style.left = points[2][0] + 'px'
            controls[2].style.top = points[2][1] + 'px'

            break
        default:
            break
    }

    options.points = points
    options.controls = controls
}

const createPlane = (imgSrc) => {
    let { canvas, controls, points, mode } = options

    let image = new Image()
    image.onload = () => {
        draw()
    }

    createPatternFromImage(imgSrc, 200, 800).then((imgBase64) => {
        image.setAttribute('src', imgBase64)
    })

    canvas = document.getElementById('dynamic-cube-canvas')
    canvas.setAttribute('width', options.width)
    canvas.setAttribute('height', options.height)

    let context = canvas.getContext('2d')
    context.clearRect(0, 0, canvas.width, canvas.height)
    context.clip(new Path2D(options.pathData))

    controls = []
    for (let i = 0; i < 6; i++) {
        let control = document.createElement('div')
        control.setAttribute('data-node', i)
        control.innerText = i
        control.classList.add('node')
        canvas.parentNode.insertBefore(control, canvas.nextSibling)
        controls.push(control)
    }

    controls[0].style.left = points[0][0] + 'px'
    controls[0].style.top = points[0][1] + 'px'

    controls[1].style.left = points[1][0] + 'px'
    controls[1].style.top = points[1][1] + 'px'

    controls[2].style.left = points[2][0] + 'px'
    controls[2].style.top = points[2][1] + 'px'

    controls[3].style.left = points[3][0] + 'px'
    controls[3].style.top = points[3][1] + 'px'

    if (mode == 1) {
        controls[2].style.display = 'none'
        controls[3].style.display = 'none'
    }

    controls[4].style.left = points[4][0] + 'px'
    controls[4].style.top = points[4][1] + 'px'

    controls[5].style.left = points[5][0] + 'px'
    controls[5].style.top = points[5][1] + 'px'

    options.image = image
    options.controls = controls
    options.canvas = canvas
    options.context = context
}

const renderPlane = (tri, number) => {
    const { context, showFrame, image } = options

    options.context = context

    if (image) {
        drawTriangle(
            context,
            image,
            tri.p0.x,
            tri.p0.y,
            tri.p1.x,
            tri.p1.y,
            tri.p2.x,
            tri.p2.y,
            tri.t0.u,
            tri.t0.v,
            tri.t1.u,
            tri.t1.v,
            tri.t2.u,
            tri.t2.v,
            number
        )
    }

    if (showFrame) {
        const left = (tri.p0.x + tri.p1.x + tri.p2.x) / 3
        const top = (tri.p0.y + tri.p1.y + tri.p2.y) / 3
        const color = context.getImageData(left, top, 1, 1)
        context.strokeStyle = `rgba(${color.data[0]},${color.data[1]},${color.data[2]},0.2)`
        // context.strokeStyle = `rgba(127,76,77,0.2)`
        context.beginPath()
        context.moveTo(tri.p0.x, tri.p0.y)
        context.lineTo(tri.p1.x, tri.p1.y)
        context.lineTo(tri.p2.x, tri.p2.y)
        context.lineTo(tri.p0.x, tri.p0.y)
        context.stroke()
        context.closePath()
    }
}

const draw = (callback) => {
    const { canvas, context, dirtyTriangles } = options
    let { triangles } = options

    context.clearRect(0, 0, window.innerWidth, window.innerHeight)
    if (dirtyTriangles) {
        options.dirtyTriangles = false
        triangles = calculateGeometry()
        options.triangles = triangles
    }

    let k = 0
    for (const triangle of triangles) {
        k++
        renderPlane(triangle, k)
    }

    if (callback) callback()
}

const calculateGeometry = () => {
    const { corner_points, points, image, subs, divs } = options
    // clear triangles out
    let triangles = []

    let r = 12
    // generate subdivision

    let p = corner_points

    let p1 = new Point(p[0][0] + r, p[0][1] + r)
    let p2 = new Point(p[1][0] + r, p[1][1] + r)

    // let p3 = new Point(p[4][0] + r, p[4][1] + r)
    // let p4 = new Point(p[5][0] + r, p[5][1] + r)

    let p3 = new Point(p[2][0] + r, p[2][1] + r)
    let p4 = new Point(p[3][0] + r, p[3][1] + r)

    let dx1 = p4.x - p1.x
    let dy1 = p4.y - p1.y
    let dx2 = p3.x - p2.x
    let dy2 = p3.y - p2.y

    let imgW = image.naturalWidth
    let imgH = image.naturalHeight

    for (let sub = 0; sub < subs; ++sub) {
        let curRow = sub / subs
        let nextRow = (sub + 1) / subs

        let curRowX1 = p1.x + dx1 * curRow
        let curRowY1 = p1.y + dy1 * curRow

        let curRowX2 = p2.x + dx2 * curRow
        let curRowY2 = p2.y + dy2 * curRow

        let nextRowX1 = p1.x + dx1 * nextRow
        let nextRowY1 = p1.y + dy1 * nextRow

        let nextRowX2 = p2.x + dx2 * nextRow
        let nextRowY2 = p2.y + dy2 * nextRow

        for (let div = 0; div < divs; ++div) {
            let curCol = div / divs
            let nextCol = (div + 1) / divs

            let dCurX = curRowX2 - curRowX1
            let dCurY = curRowY2 - curRowY1
            let dNextX = nextRowX2 - nextRowX1
            let dNextY = nextRowY2 - nextRowY1

            let p1x = curRowX1 + dCurX * curCol
            let p1y = curRowY1 + dCurY * curCol

            let p2x = curRowX1 + (curRowX2 - curRowX1) * nextCol
            let p2y = curRowY1 + (curRowY2 - curRowY1) * nextCol

            let p3x = nextRowX1 + dNextX * nextCol
            let p3y = nextRowY1 + dNextY * nextCol

            let p4x = nextRowX1 + dNextX * curCol
            let p4y = nextRowY1 + dNextY * curCol

            let u1 = curCol * imgW
            let u2 = nextCol * imgW
            let v1 = curRow * imgH
            let v2 = nextRow * imgH

            let triangle1 = new Triangle(
                new Point(p1x, p1y),
                new Point(p3x, p3y),
                new Point(p4x, p4y),
                new TextCoord(u1, v1),
                new TextCoord(u2, v2),
                new TextCoord(u1, v2)
            )

            let triangle2 = new Triangle(
                new Point(p1x, p1y),
                new Point(p2x, p2y),
                new Point(p3x, p3y),
                new TextCoord(u1, v1),
                new TextCoord(u2, v1),
                new TextCoord(u2, v2)
            )

            triangles.push(triangle1)
            triangles.push(triangle2)
        }
    }

    return triangles
}

const drawTriangle = (
    ctx,
    img,
    x0,
    y0,
    x1,
    y1,
    x2,
    y2,
    sx0,
    sy0,
    sx1,
    sy1,
    sx2,
    sy2,
    number
) => {
    const { skewAngle, skewSign, subs, divs, breakRatio, mode } = options
    ctx.save()

    let denom = sx0 * (sy2 - sy1) - sx1 * sy2 + sx2 * sy1 + (sx1 - sx2) * sy0
    if (denom == 0) {
        return
    }

    let m11 =
        -(sy0 * (x2 - x1) - sy1 * x2 + sy2 * x1 + (sy1 - sy2) * x0) / denom
    let m12 = (sy1 * y2 + sy0 * (y1 - y2) - sy2 * y1 + (sy2 - sy1) * y0) / denom
    let m21 = (sx0 * (x2 - x1) - sx1 * x2 + sx2 * x1 + (sx1 - sx2) * x0) / denom
    let m22 =
        -(sx1 * y2 + sx0 * (y1 - y2) - sx2 * y1 + (sx2 - sx1) * y0) / denom
    let dx =
        (sx0 * (sy2 * x1 - sy1 * x2) +
            sy0 * (sx1 * x2 - sx2 * x1) +
            (sx2 * sy1 - sx1 * sy2) * x0) /
        denom
    let dy =
        (sx0 * (sy2 * y1 - sy1 * y2) +
            sy0 * (sx1 * y2 - sx2 * y1) +
            (sx2 * sy1 - sx1 * sy2) * y0) /
        denom

    ctx.beginPath()
    ctx.moveTo(x0, y0)
    ctx.lineTo(x1, y1)
    ctx.lineTo(x2, y2)
    ctx.closePath()

    ctx.clip()

    ctx.transform(m11, m12, m21, m22, dx, dy)

    ctx.globalAlpha = opacity

    if (mode == 1 || number <= subs * 2 * breakRatio) {
        ctx.drawImage(img, 0, 0)
    } else {
        // calc the 45 degree skew angle needed by ctx.transform
        // move to the bottom of the original image
        ctx.translate(0, (breakRatio / subs) * img.height)
        ctx.scale(1, -1)
        ctx.transform(1, 0, skewSign * Math.tan(skewAngle), 1, 0, 0)
        //ctx.scale(1, 1.50);

        // flip reflected image
        ctx.rotate(Math.PI)
        ctx.scale(-1, 1)

        // draw the reflected image
        ctx.drawImage(img, 0, -((breakRatio / subs) * img.height))
    }

    ctx.restore()
}

const angleOf = (fromIndex, toIndex) => {
    const { points } = options
    return Math.atan2(
        points[fromIndex][1] - points[toIndex][1],
        points[fromIndex][0] - points[toIndex][0]
    )
}

const lengthOf = (fromIndex, toIndex) => {
    const { points } = options
    return Math.sqrt(
        Math.pow(points[fromIndex][0] - points[toIndex][0], 2) +
            Math.pow(points[fromIndex][1] - points[toIndex][1], 2)
    )
}

// point class

export const Point = function (x, y) {
    this.x = x ? x : 0
    this.y = y ? y : 0
}

Point.prototype.length = function (point) {
    point = point ? point : new Point()
    let xs = 0,
        ys = 0
    xs = point.x - this.x
    xs = xs * xs

    ys = point.y - this.y
    ys = ys * ys
    return Math.sqrt(xs + ys)
}

export const TextCoord = function (u, v) {
    this.u = u ? u : 0
    this.v = v ? v : 0
}

export const Triangle = function (p0, p1, p2, t0, t1, t2) {
    this.p0 = p0
    this.p1 = p1
    this.p2 = p2

    this.t0 = t0
    this.t1 = t1
    this.t2 = t2
}
